<template>
  <vue-scroll>
    <rabbey-toolbox :call-new="callNew" />

    <div class="flex column">
      <el-row>
        <el-col :span="24">
          <rabbey-table2
            ref="rTable"
            :columns="columns"
            :actions="actions"
            @rtable-push-action="handlePushAction"
          />
        </el-col>
      </el-row>
    </div>

    <el-drawer
      :title="title"
      size="30%"
      :with-header="true"
      :visible.sync="drawer"
      @closed="handleClosed"
    >
      <el-container direction="vertical">
        <el-main>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form
                ref="el_form"
                :model="model"
                label-position="left"
                size="mini"
                label-width="120px"
              >
                <el-form-item label="Nombre" prop="Name">
                  <el-input
                    v-model="model.Name"
                    :disabled="isView"
                    autofocus
                  ></el-input>
                </el-form-item>

                <el-form-item label="" label-width="0">
                  <el-button
                    v-if="!isView"
                    type="primary"
                    v-loading="loading"
                    @click="onSubmit"
                    >{{ button_submit_text }}</el-button
                  >
                  <el-button @click="drawer = false">Cancel</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-drawer>
  </vue-scroll>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: "Coins",
  data() {
    return {
      isEdit: false,
      isView: false,
      drawer: false,
      title: "Crear",
      columns: [
        {
          prop: "Id",
          name: "#",
          fixed: true,
          width: 75,
          aling: "center"
        },
        {
          prop: "Name",
          name: "Nombre",
          minWidth: 150
        }
      ],
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view"
        },
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit"
        },
        {
          icon: "el-icon-delete",
          label: "Eliminar",
          command: "delete"
        }
      ],
      model: {
        Name: null,
        Id: null,
        IsEnabled: true,
        IsNull: true
      },
      button_submit_text: "Crear",
      loading: false
    };
  },
  created() {
    this.$store.dispatch("rabbey_table/getItems", {
      url: "/api/currency/All"
    });
  },
  methods: {
    ...mapMutations({
      removeItem: "rabbey_table/removeItem",
      pushItem: "rabbey_table/pushItem",
      updateItem: "rabbey_table/updateItem"
    }),
    handlePushAction(command) {
      Object.assign(this.model, command.row);
      switch (command.command) {
        case "view":
          this.isView = true;
          this.drawer = true;
          break;

        case "edit":
          this.isEdit = true;
          this.isView = false;
          this.button_submit_text = "Actualizar";
          this.drawer = true;
          break;

        case "delete":
          this.$confirm("Segura/o que desea eliminar este registro ?")
            .then(() => {
              this.$http
                .post(
                  "/api/currency/Disable",
                  {},
                  {
                    params: {
                      "criteria.Id": this.model.Id
                    }
                  }
                )
                .then(() => {
                  const index = this.list.findIndex(
                    (item) => item.Id === this.model.Id
                  );
                  this.removeItem(index);
                  this.$message.success("Tipo de oportunidad eliminada");
                })
                .catch(() => {
                  this.$message.error("Error al eliminar tipo de oportunidad");
                });
            })
            .catch(() => {});
          break;

        default:
          break;
      }
    },
    callNew() {
      this.button_submit_text = "Crear";
      this.isView = false;
      this.isEdit = false;
      this.drawer = true;
    },
    onSubmit() {
      this.$refs.el_form.validate((valid) => {
        if (valid) {
          this.loading = true;

          if (this.isEdit) {
            this.$http
              .put("/api/currency/Update", this.model)
              .then((resp) => {
                this.updateItem({ Id: this.model.Id, item: resp.data });
                this.drawer = false;
                this.$message.success("Fase actualizada");
              })
              .catch(() => {
                this.$message.error("Error al actualizar la fase");
              })
              .finally(() => (this.loading = false));
          } else {
            this.$http
              .post("/api/currency/Add", this.model)
              .then((resp) => {
                this.pushItem(resp.data);
                this.drawer = false;
                this.$message.success("Fase creada");
              })
              .catch(() => {
                this.$message.error("Error al crear la fase");
              })
              .finally(() => (this.loading = false));
          }
        } else {
          return false;
        }
      });
    },
    handleClosed() {
      this.$refs.el_form.resetFields();
    }
  },
  computed: mapState({ list: (state) => state.rabbey_table.items })
};
</script>

<style></style>
